/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Settings_UsernameInputs */

const vi_einvoice_settings_username = /** @type {(inputs: Einvoice_Settings_UsernameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tên đăng nhập`)
};

/**

* @param {Einvoice_Settings_UsernameInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_settings_username = /** @type {((inputs?: Einvoice_Settings_UsernameInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Settings_UsernameInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_settings_username(inputs)
});